import { IconProps } from '../IconProps';
import { StyledIcon } from '../StyledIcon';

export function CheckmarkIcon(props: IconProps) {
  const { size = 16, color, className } = props;

  return (
    <StyledIcon color={color} data-testid='linui-checkmark-icon'>
      <svg
        width={size}
        height={size}
        viewBox='0 0 13 9'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
      >
        <path
          d='M4.80109 5.60987L2.51129 3.46319L0.793945 5.0732L4.80109 8.8299L12.2429 1.85318L10.5256 0.243164L4.80109 5.60987Z'
          fill='currentColor'
        />
      </svg>
    </StyledIcon>
  );
}
